import { ActivatedRoute } from '@angular/router';
import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-provider-sites',
  templateUrl: './provider-sites.component.html',
  styleUrls: ['./provider-sites.component.css']
})
export class ProviderSitesComponent implements OnInit {
  title = "ProviderSites"
  constructor(private activatedRoute: ActivatedRoute) { }
  activeSites: any = []
  inActiveSites: any = []
  ngOnInit(): void {
    this.activatedRoute.data.subscribe((data: { providerSites: any }) => {

      this.activeSites = data.providerSites.ActiveSites || [];
      this.inActiveSites = data.providerSites.InActiveSites || [];

    });
  }

}
